/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaAccountResponse model module.
 * @module model/AqaAccountResponse
 * @version v0
 */
export default class AqaAccountResponse {
  /**
   * Constructs a new <code>AqaAccountResponse</code>.
   * @alias module:model/AqaAccountResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaAccountResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaAccountResponse} obj Optional instance to populate.
   * @return {module:model/AqaAccountResponse} The populated <code>AqaAccountResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaAccountResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaAccountResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaAccountResponse.prototype.message = undefined;

/**
 * @member {String} id
 */
AqaAccountResponse.prototype.id = undefined;

/**
 * @member {String} name
 */
AqaAccountResponse.prototype.name = undefined;

/**
 * @member {Boolean} successful
 */
AqaAccountResponse.prototype.successful = undefined;

